import React from 'react';

const BlogHeroSection = () => {
  return (
    <section aria-labelledby="blog-title" className="site-bg-hero text-center py-16 px-6">
      <h1 id="blog-title" className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        Blog
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600">
        Artigos técnicos, guias e estudos de caso focados em engenharia de software e boas práticas.
      </p>
    </section>
  );
};

export default BlogHeroSection;
